// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, update, create, get } from "./operations.js";
export {
  type ScopeMapsListOptionalParams,
  type ScopeMapsDeleteOptionalParams,
  type ScopeMapsUpdateOptionalParams,
  type ScopeMapsCreateOptionalParams,
  type ScopeMapsGetOptionalParams,
} from "./options.js";
